// The known flag names — single source of truth both EnvFeatureFlagService's
// map and useFlag() type against, so neither depends on the other's
// implementation. A runtime array, not just a type, so LocalOverrideFeatureFlagService
// can iterate it to seed localStorage. isEnabled() itself stays plain
// `string`: a future implementation (e.g. a remote-driven service) may not
// know flag names statically, and the contract shouldn't assume it does.
export const FLAG_NAMES = ['WORKBENCH_NEW_UI'] as const;
export type FlagName = typeof FLAG_NAMES[number];

export interface FeatureFlagService {
	isEnabled(flag: string): boolean;
}
